import { useState } from 'react';
import { loadRemote } from '@module-federation/runtime';

import type { ComponentType } from 'react';

import { ErrorPage } from 'App/ErrorPage';

export interface RemoteProps {
  classNameSuffix?: string;
  animationClass?: string;
  headerRoom?: number;
  headerTop?: number;
}

export function useDynamicImport() {
  const [component, setComponent] = useState<ComponentType<RemoteProps> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');

  const getRemote = async (module: string, scope: string, errorPrefix: string) => {
    setLoading(true);
    try {
      const remoteModule = await loadRemote(`${scope}/${module}`).catch(() => null);
      if (!remoteModule) {
        setErrorText(`${errorPrefix} ${scope}/${module}`);
        setComponent(null);
      }
      const { default: Component } = remoteModule as { default: ComponentType<RemoteProps> };
      setLoading(false);
      setComponent(() => Component);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorText(`${errorPrefix} ${scope}/${module}`);
      setComponent(null);
    }
  };

  const fallback = () => (!loading && errorText ? <ErrorPage message={errorText} noHeader /> : null);

  return {
    getRemote,
    Remote: component || fallback,
    loading,
  };
}
